import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoadingSubject = new BehaviorSubject<number>(0);
  isLoading$ = this.isLoadingSubject.asObservable();

  show(): void {
    this.isLoadingSubject.next(this.isLoadingSubject.value + 1);
  }

  hide(): void {
    this.isLoadingSubject.next(this.isLoadingSubject.value - 1);
  }
}
